import { analyticsLogEvent } from '@src/utils/analytics';

export const auPayAnalyticsEvents = {
  eventClickAuPayTop: () => analyticsLogEvent({ category: '【click】au PAY履歴', action: 'お金の管理トップへ' }),
  eventClickCampaignText: () => analyticsLogEvent({ category: '【click】au PAY履歴', action: 'キャンペーン情報はこちら' }),
  eventClickAupayNote: () => analyticsLogEvent({ category: '【click】au PAY履歴', action: '一部の履歴が表示されない場合' })
};
